import {AbstractNotificationListController} from "./AbstractNotificationListController";
import {Injectable} from "@angular/core";

@Injectable()
export class StandardNotificationListController extends AbstractNotificationListController {

  constructor() {
    super();
  }
}
